<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
        <div class="navbar-brand">Daily Sales Report</div>
        <div class="ms-auto d-flex flex-row">
            <div class="d-flex flex-row align-items-center px-2" style="gap: 10px">
                <span>Month/Year</span>
                <input type="month" [(ngModel)]="filterMonth" (change)="monthChange($event)"
                    class="form-control form-control-sm" *ngIf="is_mario" />
                <select class="form-control form-control-sm" [(ngModel)]="filterMonth" (change)="monthChange($event)"
                    *ngIf="!is_mario">
                    <option *ngFor="let month of months" [value]="month.value">{{month.label}}</option>
                </select>
            </div>
            <button class="btn btn-success btn-sm" (click)="save()"
                *ngIf="permission.edit_daily_report && !summary_checked">SAVE</button>
        </div>
    </div>
</nav>
<div class="text-muted small px-3 pt-1" style="opacity:.5" *ngIf="configuration">UTC{{configuration.timezone || '+08:00'}}{{configuration.currency && configuration.currency !== 'none' ? ' · ' + configuration.currency : ''}}</div>
<hr />

<table>
    <tbody *ngFor="let week of weeks; let i = index">
        <tr>
            <th colspan="15">Week {{i + 1}}</th>
        </tr>
        <tr>
            <th>Date</th>
            <th>Day</th>
            <th>Debit 进钱</th>
            <th>Credit 出钱</th>
            <th>Balance</th>
            <th>M.Bonus</th>
            <th>S.Bonus</th>
            <th>New Member</th>
            <th>Old Member</th>
            <th>No Of Topup</th>
            <th>Bank In Capital</th>
            <th>Bank Withdraw</th>
            <th *ngIf="permission.edit_daily_report">Adj In</th>
            <th *ngIf="permission.edit_daily_report">Adj Out</th>
            <th>Checked</th>
        </tr>
        <tr *ngFor="let day of week">
            <td style="background:#efdecd; color: #000; padding-left: 3px;; padding-right: 3px;">{{day.date | date:
                'dd'}}</td>
            <td style="background:#efdecd; color: #000; padding-left: 3px;; padding-right: 3px;">{{day.day}}</td>
            <td class="fw-bold" [ngClass]="{'text-danger': day.debit < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency"
                        *ngIf="day.debit != null">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{day.debit | number: '1.2-2'}}</div>
            </td>
            <td class="fw-bold" [ngClass]="{'text-danger': day.credit < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency"
                        *ngIf="day.credit != null">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{day.credit | number: '1.2-2'}}</div>
            </td>
            <td class="fw-bold" [ngClass]="{'text-danger': day.balance < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency"
                        *ngIf="day.balance != null">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{day.balance | number: '1.2-2'}}</div>
            </td>
            <td class="fw-bold" [ngClass]="{'text-danger': day.bonus < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency"
                        *ngIf="day.bonus != null">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{day.bonus | number: '1.2-2'}}</div>
            </td>
            <td class="fw-bold" [ngClass]="{'text-danger': day.seemless_bonus < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency"
                        *ngIf="day.seemless_bonus != null">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{day.seemless_bonus | number: '1.2-2'}}</div>
            </td>
            <td class="fw-bold text-center">{{day.new_member}}</td>
            <td class="fw-bold text-center">{{day.old_member}}</td>
            <td class="fw-bold text-center">{{day.ask}}</td>
            <td class="fw-bold" [ngClass]="{'text-danger': day.bank_in < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency"
                        *ngIf="day.bank_in != null">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{day.bank_in | number: '1.2-2'}}</div>
            </td>
            <td class="fw-bold" [ngClass]="{'text-danger': day.bank_out < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency"
                        *ngIf="day.bank_out != null">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{day.bank_out | number: '1.2-2'}}</div>
            </td>
            <td class="fw-bold" *ngIf="permission.edit_daily_report"><input type="number" [(ngModel)]="day.adj_in"
                    class="form-field text-center" style="width:50px" [readonly]="day.checked || summary_checked"
                    [disabled]="isFutureDate(day.date)" (input)="updateBalance(day)" /></td>
            <td class="fw-bold" *ngIf="permission.edit_daily_report"><input type="number" [(ngModel)]="day.adj_out"
                    class="form-field text-center" style="width:50px" [readonly]="day.checked || summary_checked"
                    [disabled]="isFutureDate(day.date)" (input)="updateBalance(day)" /></td>
            <td><input type="checkbox" [(ngModel)]="day.checked" [value]="true" class="mx-auto d-block"
                    [disabled]="!permission.edit_daily_report || isFutureDate(day.date) || summary_checked" /></td>
        </tr>
        <tr class="total">
            <td colspan="2">Total</td>
            <th class="fw-bold" [ngClass]="{'text-danger': sum('debit', week) < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{sum('debit', week) | number: '1.2-2'}}</div>
            </th>
            <th class="fw-bold" [ngClass]="{'text-danger': sum('credit', week) < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{sum('credit', week) | number: '1.2-2'}}</div>
            </th>
            <th class="fw-bold" [ngClass]="{'text-danger': sum('balance', week) < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{sum('balance', week) | number: '1.2-2'}}</div>
            </th>
            <th class="fw-bold" [ngClass]="{'text-danger': sum('bonus', week) < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{sum('bonus', week) | number: '1.2-2'}}</div>
            </th>
            <th class="fw-bold" [ngClass]="{'text-danger': sum('seemless_bonus', week) < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{sum('seemless_bonus', week) | number: '1.2-2'}}</div>
            </th>
            <th class="text-center">{{sum('new_member', week) | number: '1.0-0'}}</th>
            <th class="text-center">{{sum('old_member', week) | number: '1.0-0'}}</th>
            <th class="text-center">{{sum('ask', week) | number: '1.0-0'}}</th>
            <th class="fw-bold" [ngClass]="{'text-danger': sum('bank_in', week) < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{sum('bank_in', week) | number: '1.2-2'}}</div>
            </th>
            <th class="fw-bold" [ngClass]="{'text-danger': sum('bank_out', week) < 0}">
                <div class="d-flex" [class.justify-content-between]="!configuration.hide_dashboard_currency"
                    [class.justify-content-end]="configuration.hide_dashboard_currency"><span
                        [class.d-none]="configuration.hide_dashboard_currency">{{configuration.currency == "none" ? "":
                        configuration.currency}}</span>{{sum('bank_out', week) | number: '1.2-2'}}</div>
            </th>
            <td *ngIf="permission.edit_daily_report"></td>
            <td *ngIf="permission.edit_daily_report"></td>
            <td></td>
        </tr>
        <tr>
            <th colspan="14" style="height:30px; background: var(--bs-body-bg)"></th>
        </tr>
    </tbody>

    <tbody>
        <tr>
            <th colspan="2"></th>
            <th>Debit 进钱</th>
            <th>Credit 出钱</th>
            <th>Balance</th>
            <th>M.Bonus</th>
            <th>S.Bonus</th>
            <th>New Member</th>
            <th>Old Member</th>
            <th>No Of Topup</th>
            <th>Bank In Capital</th>
            <th>Bank Withdraw</th>
            <th *ngIf="permission.edit_daily_report"></th>
            <th *ngIf="permission.edit_daily_report"></th>
            <th></th>
        </tr>
        <tr class="total-summary">
            <th colspan="2">Total</th>
            <th [ngClass]="{'text-danger': sum('debit', flattern(weeks)) < 0}">{{sum('debit', flattern(weeks)) | number:
                '1.2-2'}}</th>
            <th [ngClass]="{'text-danger': sum('credit', flattern(weeks)) < 0}">{{sum('credit', flattern(weeks)) |
                number: '1.2-2'}}</th>
            <th [ngClass]="{'text-danger': sum('balance', flattern(weeks)) < 0}">{{sum('balance', flattern(weeks)) |
                number: '1.2-2'}}</th>
            <th [ngClass]="{'text-danger': sum('bonus', flattern(weeks)) < 0}">{{sum('bonus', flattern(weeks)) | number:
                '1.2-2'}}</th>
            <th [ngClass]="{'text-danger': sum('seemless_bonus', flattern(weeks)) < 0}">{{sum('seemless_bonus',
                flattern(weeks)) | number: '1.2-2'}}</th>
            <th>{{sum('new_member', flattern(weeks)) | number: '1.0-0'}}</th>
            <th>{{sum('old_member', flattern(weeks)) | number: '1.0-0'}}</th>
            <th>{{sum('ask', flattern(weeks)) | number: '1.0-0'}}</th>
            <th [ngClass]="{'text-danger': sum('bank_id', flattern(weeks)) < 0}">{{sum('bank_in', flattern(weeks)) |
                number: '1.2-2'}}</th>
            <th [ngClass]="{'text-danger': sum('bank_out', flattern(weeks)) < 0}">{{sum('bank_out', flattern(weeks)) |
                number: '1.2-2'}}</th>
            <th *ngIf="permission.edit_daily_report">{{sum('adj_in', flattern(weeks)) | number: '1.2-2'}}</th>
            <th *ngIf="permission.edit_daily_report">{{sum('adj_out', flattern(weeks)) | number: '1.2-2'}}</th>
            <th></th>
        </tr>
    </tbody>
</table>

<div class="form-group col-12 col-md-4 mt-3">
    <label for="exampleInputEmail1">Other Profit</label>
    <input class="form-control" [(ngModel)]="other_profit"
        [disabled]="!permission.edit_daily_report || summary_checked" />
</div>